<div class="page-placeholder">Page content here</div>
<div class="tab-bar">
	<div class="add-tab editable">Add tab</div>
</div>
